__turbopack_context__.v({
  "actions": "Hero-module-scss-module__T_l2EW__actions",
  "componentIcon": "Hero-module-scss-module__T_l2EW__componentIcon",
  "hero": "Hero-module-scss-module__T_l2EW__hero",
  "icon": "Hero-module-scss-module__T_l2EW__icon",
  "title": "Hero-module-scss-module__T_l2EW__title",
});
